<!--<script>-->
<!--    import {Bar, Doughnut, Pie} from 'vue-chartjs'-->
<!--    import {base_url} from "../../http";-->

<!--    export default {-->
<!--        extends: Doughnut,-->
<!--        name: "paymentType",-->
<!--        data() {-->
<!--            return {-->
<!--                loading: true,-->

<!--                chartdata: {-->
<!--                    labels: [],-->
<!--                    datasets: [{-->
<!--                        label: 'Тип оплаты',-->
<!--                        data: [],-->
<!--                        backgroundColor: [-->
<!--                            '#FFDA83',-->
<!--                            '#FF8373',-->
<!--                            '#55D8FE',-->
<!--                            // 'rgba(255, 159, 64, 0.2)'-->
<!--                        ],-->
<!--                        borderColor: [-->
<!--                            '#FFDA83',-->
<!--                            '#FF8373',-->
<!--                            '#55D8FE',-->
<!--                            // 'rgba(255, 159, 64, 1)'-->
<!--                        ],-->

<!--                        borderWidth: 1-->
<!--                    }]-->
<!--                },-->
<!--                options: {-->
<!--                    responsive: true,-->
<!--                    maintainAspectRatio: false,-->
<!--                    legend: {-->
<!--                        position: 'bottom',-->
<!--                        align: 'start',-->
<!--                        labels: {-->
<!--                            boxWidth: 10,-->
<!--                            fontSize: 16,-->
<!--                            fontColor: '#000000',-->
<!--                            padding: 30,-->
<!--                            fontStyle: 'bold',-->
<!--                            fontFamily: 'Gilroy',-->
<!--                            usePointStyle: true-->

<!--                        }-->

<!--                    }-->
<!--                    // scales: {-->
<!--                    //   yAxes: [{-->
<!--                    //     ticks: {-->
<!--                    //       beginAtZero: true-->
<!--                    //     }-->
<!--                    //   }]-->
<!--                    // }-->
<!--                }-->



<!--            };-->
<!--        },-->

<!--        // Загружаем данные для таблицы-->
<!--        methods: {-->
<!--            fetchPaymentType: function () {-->
<!--                this.loading = true;-->
<!--                this.lastDraw++;-->
<!--                let url = `${base_url}/charts/payment_type/`;-->
<!--                this.$http-->
<!--                    .get(url, {-->
<!--                        // params: this.fetchParams-->
<!--                    })-->
<!--                    .then(result => {-->
<!--                        // if (result.data.draw === this.lastDraw) {-->
<!--                        result.data.forEach(product => {-->
<!--                            this.chartdata.labels.push(product.type);-->
<!--                            this.chartdata.datasets[0].data.push(product.sum);-->
<!--                        });-->

<!--                        this.renderChart(this.chartdata, this.options);-->
<!--                        // this.data.top_products = result.data;-->
<!--                        // this.totalRecords = result.data.count;-->
<!--                        // }-->
<!--                    })-->
<!--                    .finally(() => {-->
<!--                        this.loading = false;-->
<!--                    });-->
<!--            },-->
<!--        },-->
<!--        mounted: function () {-->
<!--            this.fetchPaymentType();-->
<!--        }-->
<!--    };-->
<!--</script>-->

<!--<style scoped>-->
<!--</style>-->



<script>
    import { Doughnut } from 'vue-chartjs'
    import { base_url } from "../../http";
    export default {
        extends: Doughnut,
        name: "paymentType",
        props: {
            // chartdata: Object,
            labels: Array,
            data: Array
        },
        data() {
            return {
                // loading: true,
                chartdata: {
                    labels: [],
                    datasets: [
                        {
                            label: "Тип оплаты",
                            data: [],
                            backgroundColor: [
                                "#FFDA83",
                                '#FF8373',
                                '#55D8FE'
                            ],
                            borderColor: [
                                "#FFDA83",
                                '#FF8373',
                                '#55D8FE'
                            ],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    // scales: {
                    //   yAxes: [{
                    //     ticks: {
                    //       beginAtZero: true
                    //     }
                    //   }]
                    // }
                }
            };
        },
        mounted() {
            this.chartdata.datasets[0].data = this.data;
            this.chartdata.labels = this.labels;
            this.renderChart(this.chartdata, this.options);
        },
        watch: {
            // "chartdata":
            //   {
            //     handler: function () {
            //       this.renderChart(this.chartdata, this.options);
            //     },
            //     deep: true
            //   },
            "data": function() {
                this.chartdata.datasets[0].data = this.data;
                this.chartdata.labels = this.labels;
                this.renderChart(this.chartdata, this.options);
            }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/apps/home/paymentType.vue